module.exports = __webpack_public_path__ + "img/sk.8fff59a6.svg";